let Backbone = require("backbone");


var PosRouter = Backbone.Router.extend({
    app: null,

    routes: {
        "overview": "overview",
        "table/:id": "table",
        "etable/:id": "etable",
        "order(/:tableId)": "order",
        "settings": "settings",
        "settings/:type": "settings",
        "settings/:type/:tag": "settings",
        "cashier(/:tableId)(/:billId)": "cashier",
        "onlineOrder": "onlineOrder",
        "sales": "sales",
        "notifications": "notifications"
    },

    checkLicense: function () {
        if (!this.hasBaseFeature) {
            this.trigger('changeState', ['#settings', {type: "license"}]);
            return false;
        }
        return true;
    },

    overview: function () {
        if (this.checkLicense()) {
            this.trigger('changeState', '#overview');
        }
    },

    table: function (id) {
        if (this.checkLicense()) {
            this.trigger('changeState', ['#table', id]);
        }
    },

    /**
     * Enter table page for empty tables
     * @param id
     */
    etable: function (id) {
        if (this.checkLicense()) {
            this.trigger('changeState', ['#table', id, true]);
        }
    },

    order: function (id) {
        if (this.checkLicense()) {
            this.trigger('changeState', ['#order', id]);
        }
    },

    notifications:function(){
        if (this.checkLicense()) {
            this.trigger('changeState', '#notifications');
        }
    },

    sales: function (id) {
        if (this.checkLicense()) {
            this.trigger('changeState', '#sales');
        }
    },

    settings: function (type, tag) {
        switch(type) {
            case "membershipSetting":
                mixpanel.track("打开会员管理");
                break;
            case "menu":
                mixpanel.track("打开菜单设置");
                break;
            case "discount":
                mixpanel.track("打开折扣设置");
                break;
            case "table":
                mixpanel.track("打开餐桌管理");
                break;
            case "user":
                mixpanel.track("打开员工管理");
                break;
            case "print":
                mixpanel.track("打开打印机设置");
                break;
            case "restaurant":
                switch(tag) {
                    case "wechat":
                        mixpanel.track("打开微信设置");
                        break;
                    case "orderweb":
                        mixpanel.track("打开外卖设置");
                        break;
                    default:
                        mixpanel.track("打开餐馆设置");
                }
                break;
        }
        if (this.checkLicense()) {
            this.trigger('changeState', ['#settings', {type: type, tag: tag}]);
        }
    },

    cashier: function (tableId, billId) {
        console.log("cashier route");
        if (this.checkLicense()) {
            this.trigger('changeState', ['#cashier', {tableId: tableId, billId: billId}]);
        }
    },

    onlineOrder: function () {
        if (this.checkLicense()) {
            this.trigger('changeState', ['#onlineOrder']);
        }
    }

});

module.exports = PosRouter;


// WEBPACK FOOTER //
// ./src/PosRouter.js